// extracted by mini-css-extract-plugin
module.exports = {"itemTitle":"itemTitle--2UQY9"};